// import ModalForm from "./Form";
import ChildrenInfoTableForm from "./ChildrenInfoTableForm";
import { CHILDREN_INFO, DATATABLE_EXPORT } from "../../../../../Config/ApiUrl";
import * as actions from "../../../../../Config/ApiUrl";

export const ChildrenInfoSchema = {
	components: { ChildrenInfoTableForm },

	data() {
		return {
			DATATABLE_EXPORT,
			isAddEditModalActive: false,
			deleteConfirmationModalActive: false,
			deleteLoader: false,
			selectedUrl: this.ENDPOINT,
			tableId: "children-info-table",
			formId: "children-info-table-form",
			rowData: {},
			tableColumns: [
				{
					title: "First Name",
					type: "text",
					key: "name",
				},
				{
					title: "Last Name",
					type: "text",
					key: "surname",
				},
				{
					title: "Date of Birth",
					type: "text",
					key: "date_of_birth",
				},
				{
					title: "School Name",
					type: "custom-html",
					key: "school",
					modifier: (value) => {
						return value?.name
					}
				},
				{
					title: "School Level",
					type: "custom-html",
					key: "school_level",
					modifier: (value) => {
						return value?.name
					}
				},
				{
					title: "Status",
					type: "custom-html",
					key: "status",
					modifier: (value) => {
						if (value && value.status) {
							return `<span class="badge badge-sm badge-pill badge-${value.color_status ?? 'primary'}">${this.$t(
								value.status
							)}</span>`;
						}
					},
				},
				{
					title: "CLC ID No",
					type: "text",
					key: "clc_id_number",
				},
			],
			ENDPOINT: CHILDREN_INFO + "/" + this.parentId + "/children",
			actionObj: {
				title: this.$t("action"),
				type: "action",
			},
			options: {
				name: "ChildrenInfoTable",
				url: CHILDREN_INFO + "/" + this.parentId + "/children",
				showHeader: true,
				enableHighlights: true,
				// enableRowSelect: true,
				enableSaveFilter: true,
				columns: [],
				showFilter: true,
				showSearch: true,
				showCount: true,
				showClearFilter: true,
				paginationType: "pagination",
				responsive: true,
				rowLimit: 3,
				showAction: false,
				orderBy: "desc",
			},
		};
	},
	methods: {},
};
